/**
 * This file is auto-generated from ChatBirthDateInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const submitButton: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Continue';
        case 'pl':
            return 'Kontynuuj';
    }
};

export const enterBirthDate: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Please enter your birth date';
        case 'pl':
            return 'Proszę podać datę urodzenia';
    }
};

export const birthDateInFuture: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Birth date cannot be in the future';
        case 'pl':
            return 'Data urodzenia nie może być w przyszłości';
    }
};
